import React from 'react';
import ReactDOM from 'react-dom';

import SearchApp from './components/SearchApp';

const searchContainer = document.querySelector('.js-search-container');

function getUrlParameter(field) {
    const href = window.location.href;
    const reg = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
    const param = reg.exec(href);

    return param ? decodeURIComponent(param[1]) : null;
}

if (searchContainer) {
    const query = getUrlParameter('q');

    const searchConfig = {};

    ReactDOM.render(
        <SearchApp config={searchConfig} defaultQuery={query} />,
        searchContainer,
    );
}
